import { Button, styled } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import FileUploadIcon from "@mui/icons-material/FileUpload";

interface IFileUpload {
  className?: string;
  name: string;
  errors?: any;
  onChange?: any;
  accept?: string;
}

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  position: "relative",
  height: "55px",
  backgroundColor: "#0063cc",
  color: "#FFF",
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
  "&:hover": {
    backgroundColor: "#1521b1",
  },
});

const FileUploadInput: FC<IFileUpload> = (props) => {
  const { name, onChange, accept } = props;
  const { t } = useTranslation();

  /* const configTextfield = {
    ...field,
    ...props,
    fullWidth: true,
    value: isExists(field.value) ? field.value : "",
  }; */
  return (
    <>
      <BootstrapButton
        size="large"
        fullWidth
        sx={{ height: "50px" }}
        startIcon={<FileUploadIcon sx={{ color: "#FFF" }} />}
        style={{ height: "56px" }}
      >
        {t("select_file")}
        <input
          accept={accept}
          //id="file-input"
          name={name}
          type="file"
          onChange={onChange}
        />
      </BootstrapButton>
      {/* {meta.touched && meta.error ? (
        <FormHelperText>{meta.error}</FormHelperText>
      ) : null} */}
    </>
  );
};

export default FileUploadInput;
